export default "__VITE_ASSET__CoYoWcMZ__"